/* eslint @typescript-eslint/no-explicit-any: 0 */

import React from 'react';

import Tracked from '~/components/Tracked';
import type { MenuItemProps } from '~/legacy/types';
import { logoIcons } from '~/legacy/utils';
import type { TrackedButtonClickName } from '~/services/gtm.client';

import CategoryList from './CategoryList';
import MenuLink from './MenuLink';

const MenuItem = ({
  link,
  name,
  content,
  slug,
  track,
  pagePosition
}: MenuItemProps) => {
  const isSale = name === 'Sale';

  return (
    <li
      className={`main-header__nav__top-list-item ${isSale ? 'flex h-8 items-center bg-red-alert hover:cursor-pointer hover:bg-red-alert-light' : ''}`}
    >
      <Tracked.ExternalLink
        name={name as TrackedButtonClickName}
        href={link}
        variant="none"
        className={
          isSale
            ? 'px-3 font-bold leading-tight text-white'
            : 'main-header__nav__top-list-item--link flex'
        }
        pagePosition="Header"
      >
        {name}
      </Tracked.ExternalLink>
      {content?.render ? (
        <div className="main-header__nav__sub-nav-list">
          <div className="main-header__nav__sub-nav-list--offset"></div>
          <div className="main-header__nav__sub-nav-list--container">
            <div className="main-header__nav__sub-nav-list--wrapper">
              <div className="flex w-full flex-col">
                {/* Footwear SubMenu Filters */}
                <div className="main-header__sub-nav-list__top-filters">
                  <div className="main-header__sub-nav-list__top-filters__title">
                    {content?.footwear?.title}
                  </div>
                  {content?.footwear?.filters.map((item: MenuItemProps) => (
                    <React.Fragment key={`${item?.title}/${item?.link}`}>
                      <MenuLink
                        title={item?.title}
                        link={item?.link}
                        track={track}
                        pagePosition={pagePosition}
                      />
                    </React.Fragment>
                  ))}
                </div>

                <div className="main-header__sub-nav-list__header">
                  <div className="main-header__sub-nav-list__header--title">
                    Featured brands
                  </div>
                  {content?.footwear?.viewAll && (
                    <Tracked.ExternalLink
                      className="main-header__sub-nav-list__header--link"
                      variant="none"
                      href={content?.footwear.viewAll.link}
                      pagePosition="Header"
                      name={'View all brands' as TrackedButtonClickName}
                    >
                      View all brands
                    </Tracked.ExternalLink>
                  )}
                </div>

                {content?.footwear?.featuredBrands && (
                  <div
                    className={`main-header__sub-nav-list__footwear-featured-brands${
                      content?.footwear?.featuredBrands.path === 'clothing'
                        ? '-clothing'
                        : ''
                    }`}
                  >
                    {content?.footwear?.featuredBrands.children.map(
                      (item: any, i: number) => {
                        const { children, icon, name, viewAll, path } = item;

                        return (
                          <div key={i} className="subNavFeaturedBrands">
                            {icon ? (
                              <Tracked.ExternalLink
                                variant="none"
                                href={`${path}${viewAll?.link || ''}`}
                                pagePosition="Header"
                                name={name as TrackedButtonClickName}
                              >
                                <img
                                  alt={name}
                                  src={logoIcons[icon]}
                                  loading="lazy"
                                  className="subNavFeaturedBrands__icon"
                                />
                              </Tracked.ExternalLink>
                            ) : (
                              slug
                            )}
                            {children && (
                              <>
                                <Tracked.ExternalLink
                                  href={`${path}${viewAll?.link || ''}`}
                                  className="subNavFeaturedBrands__viewAll"
                                  variant="none"
                                  pagePosition="Header"
                                  name={viewAll.label as TrackedButtonClickName}
                                >
                                  {viewAll.label}
                                </Tracked.ExternalLink>
                                {children?.map(
                                  (brand: MenuItemProps, i: number) => (
                                    <Tracked.ExternalLink
                                      className="subNavFeaturedBrands__brand"
                                      key={`sub_brand_${i}`}
                                      href={`${path}${brand?.slug}/`}
                                      pagePosition="Header"
                                      variant="none"
                                      name={
                                        brand.name as TrackedButtonClickName
                                      }
                                    >
                                      {brand?.name}
                                    </Tracked.ExternalLink>
                                  )
                                )}
                              </>
                            )}
                          </div>
                        );
                      }
                    )}
                  </div>
                )}
                {content?.footwear?.categories && (
                  <div className="main-header__sub-nav-list__extended-category">
                    {content?.footwear?.categories?.sport && (
                      <CategoryList
                        title={content?.footwear?.categories?.sport.title}
                        children={content?.footwear?.categories?.sport.children}
                        parentLink={content?.footwear?.categories?.sport.link}
                      />
                    )}

                    {content?.footwear?.categories?.style && (
                      <CategoryList
                        title={content?.footwear?.categories?.style.title}
                        children={content?.footwear?.categories?.style.children}
                        parentLink={content?.footwear?.categories?.style.link}
                      />
                    )}

                    {content?.footwear?.categories?.material && (
                      <CategoryList
                        title={content?.footwear?.categories?.material.title}
                        children={
                          content?.footwear?.categories?.material.children
                        }
                        parentLink={
                          content?.footwear?.categories?.material.link
                        }
                      />
                    )}

                    {content?.footwear?.categories?.colour && (
                      <CategoryList
                        title={content?.footwear?.categories?.colour.title}
                        children={
                          content?.footwear?.categories?.colour.children
                        }
                        parentLink={content?.footwear?.categories?.colour.link}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </li>
  );
};

export default MenuItem;
